import React, { useState, useEffect, useRef } from "react"
import { connect } from "react-redux"
import { useHistory } from "react-router"
import styled from "styled-components"
import { Modal } from "antd"
import { get, post } from "../../../netApi/fetch"

// 主容器
const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
  background: #fff;
  min-height: 100vh;
`

// 导航栏容器
const NavContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  background: #fff;
`

// 导航项
const NavItem = styled.div<{ active: boolean; isTrash?: boolean }>`
  padding: 16px 32px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s;
  color: ${(props) => {
    if (props.isTrash) {
      return props.active ? "#ff4d4f" : "#999"
    }
    return props.active ? "var(--theme-main)" : "#666"
  }};
  margin: 0 8px;

  &:hover {
    color: ${(props) => (props.isTrash ? "#ff4d4f" : "var(--theme-main)")};
  }
`

// 内容区域
const ContentArea = styled.div`
  width: 100%;
`

// 内容项容器
const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
`

// 视频内容项
const VideoItem = styled.div`
  border: 1px solid rgb(240, 240, 240);
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`

// 视频预览容器
const VideoPreview = styled.div`
  width: 100%;
  height: 180px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
  }
`

// 音频内容项
const AudioItem = styled.div`
  border: 1px solid rgb(240, 240, 240);
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`

// 音频容器
const AudioContainer = styled.div`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 12px;

  audio {
    width: 100%;
    height: 60px;
    outline: none;

    &::-webkit-media-controls-panel {
      background-color: #f5f5f5;
    }

    &::-webkit-media-controls-play-button,
    &::-webkit-media-controls-pause-button {
      background-color: var(--theme-main);
      border-radius: 50%;
    }
  }
`

// 文本内容项（回收站）
const TextItem = styled.div`
  border: 1px solid rgb(240, 240, 240);
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  cursor: default;
`

// 内容文本
const ContentText = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

// 时间标签
const TimeLabel = styled.div`
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

// 删除按钮
const DeleteButton = styled.button`
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 8px;

  &:hover {
    background: #ff7875;
  }
`

// 恢复按钮
const RestoreButton = styled.button`
  background: var(--theme-main);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.8;
  }
`

// 清空回收站按钮
const ClearTrashButton = styled.button`
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 20px;

  &:hover {
    background: #ff7875;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`

// 加载更多按钮
const LoadMoreButton = styled.div`
  width: 100%;
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: var(--theme-main);
  }
`

// 空状态
const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #999;

  .icon {
    font-size: 64px;
    margin-bottom: 16px;
    opacity: 0.3;
  }

  .text {
    font-size: 16px;
  }
`

const navItems = [
  { key: "avatar", label: "AI形象" },
  { key: "voice", label: "AI语音" },
  { key: "trash", label: "回收站" },
]

interface ContentLibraryProps {
  user: any
  loginBindInfo: any
}

function ContentLibrary(props: ContentLibraryProps) {
  const history = useHistory()
  const urlParams = new URLSearchParams(window.location.search)
  const tabFromUrl = urlParams.get("tab")

  // 验证tab是否合法，不合法则使用默认值
  const validTabs = ["avatar", "voice", "trash"]
  const initialTab = validTabs.includes(tabFromUrl) ? tabFromUrl : "avatar"

  const [activeTab, setActiveTab] = useState(initialTab)
  const [contentList, setContentList] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const offsetRef = useRef(0)
  const limit = 20
  const isLoadingRef = useRef(false)

  // 如果URL中的tab不合法，更新URL为默认tab
  useEffect(() => {
    if (tabFromUrl && !validTabs.includes(tabFromUrl)) {
      const newUrl = new URL(window.location.href)
      newUrl.searchParams.set("tab", "avatar")
      history.replace(newUrl.pathname + newUrl.search)
    }
    // 滚动到顶部
    window.scrollTo(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // 获取内容列表
  const getContentList = async (reset = false, targetTab = activeTab) => {
    if (isLoadingRef.current) return

    isLoadingRef.current = true
    setIsLoading(true)
    const currentOffset = reset ? 0 : offsetRef.current

    try {
      let apiEndpoint = ""
      let params: any = {
        offset: currentOffset,
        limit: limit,
      }

      switch (targetTab) {
        case "avatar":
          // 获取AI形象内容列表
          // 返回格式: { list: [{ id, title, content, mp4: {url}, thumbnail, createtime, status }], count }
          apiEndpoint = "/content/avatarlist"
          break
        case "voice":
          // 获取AI语音内容列表
          // 返回格式: { list: [{ id, title, content, audio: {url}, duration, createtime, status }], count }
          apiEndpoint = "/content/voicelist"
          break
        case "trash":
          // 获取回收站内容列表
          // 返回格式: { list: [{ id, title, content, type, createtime, deleted_time }], count }
          apiEndpoint = "/content/trashlist"
          break
      }

      const res = await get(apiEndpoint, params)

      // 检查当前请求是否还对应当前tab，避免快速切换时数据错乱
      if (targetTab !== activeTab) {
        console.log(`Tab已从${targetTab}切换到${activeTab}，忽略返回数据`)
        return
      }

      if (reset) {
        setContentList(res.list || [])
        offsetRef.current = res.list?.length || 0
      } else {
        setContentList((prev) => [...prev, ...(res.list || [])])
        offsetRef.current = offsetRef.current + (res.list?.length || 0)
      }

      setHasMore((res.list?.length || 0) === limit)
    } catch (error) {
      console.error("获取内容列表失败:", error)
      // 临时模拟数据用于测试，也要检查tab是否还对应
    } finally {
      isLoadingRef.current = false
      setIsLoading(false)
    }
  }

  // 切换标签时重新加载
  useEffect(() => {
    setContentList([])
    offsetRef.current = 0
    setHasMore(true)
    getContentList(true, activeTab)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  // 滚动到底部加载更多
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight

      if (scrollTop + clientHeight >= scrollHeight - 100 && hasMore && !isLoadingRef.current) {
        getContentList(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMore])

  // 点击内容项
  const handleContentClick = (item: any) => {
    if (activeTab !== "trash") {
      // 跳转到编辑页面
      history.push(`/content/${item.id}`)
    }
  }

  // 删除回收站项目
  const handleDeleteItem = async (item: any, e: React.MouseEvent) => {
    e.stopPropagation()
    Modal.confirm({
      title: "确认删除",
      content: "确定要彻底删除这个项目吗？删除后无法恢复！",
      okText: "确定删除",
      cancelText: "取消",
      okType: "danger",
      onOk: async () => {
        try {
          // 彻底删除回收站项目
          await post("/content/permanentdelete", { id: item.id })
          console.log("彻底删除:", item.id)

          // 从列表中移除
          setContentList((prev) => prev.filter((i) => i.id !== item.id))
        } catch (error) {
          console.error("删除失败:", error)
        }
      },
    })
  }

  // 恢复回收站项目
  const handleRestoreItem = async (item: any, e: React.MouseEvent) => {
    e.stopPropagation()
    Modal.confirm({
      title: "确认恢复",
      content: `确定要恢复"${item.title}"吗？`,
      okText: "确定恢复",
      cancelText: "取消",
      onOk: async () => {
        try {
          // 恢复回收站项目
          // 请求格式: { id: string }
          // 返回格式: { success: boolean, message: string }
          await post("/content/restore", { id: item.id })
          console.log("恢复内容:", item.id)

          // 从回收站列表中移除
          setContentList((prev) => prev.filter((i) => i.id !== item.id))
        } catch (error) {
          console.error("恢复失败:", error)
        }
      },
    })
  }

  // 清空回收站
  const handleClearTrash = async () => {
    if (contentList.length === 0) return

    Modal.confirm({
      title: "清空回收站",
      content: `确定要清空回收站吗？将彻底删除${contentList.length}个项目，删除后无法恢复！`,
      okText: "确定清空",
      cancelText: "取消",
      okType: "danger",
      onOk: async () => {
        try {
          // 清空回收站
          await post("/content/cleartrash", {})
          console.log("清空回收站")

          // 清空列表
          setContentList([])
        } catch (error) {
          console.error("清空失败:", error)
        }
      },
    })
  }

  // 切换标签并更新URL
  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey)
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set("tab", tabKey)
    history.replace(newUrl.pathname + newUrl.search)
  }

  // 渲染视频内容项
  const renderVideoItem = (item: any) => (
    <VideoItem key={item.id} onClick={() => handleContentClick(item)}>
      <VideoPreview>
        {item.video_url ? (
          <video>
            <source src={item.video_url} type="video/mp4" />
          </video>
        ) : (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#ccc" }}>暂无预览</div>
        )}
        <div className="play-button">▶</div>
      </VideoPreview>
      <ContentText>{item.content}</ContentText>
      <TimeLabel>
        <span>{item.createtime}</span>
        {item.status === "2" && <span style={{ color: "var(--theme-main)" }}>生成中</span>}
      </TimeLabel>
    </VideoItem>
  )

  // 渲染音频内容项
  const renderAudioItem = (item: any) => (
    <AudioItem key={item.id} onClick={() => handleContentClick(item)}>
      <AudioContainer>
        {item.audio_url ? (
          <audio controls onClick={(e) => e.stopPropagation()}>
            <source src={item.audio_url} type="audio/mpeg" />
            您的浏览器不支持音频播放。
          </audio>
        ) : (
          <div
            style={{
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f5f5f5",
              borderRadius: "8px",
              color: "#ccc",
            }}
          >
            暂无音频
          </div>
        )}
      </AudioContainer>
      <ContentText>{item.content}</ContentText>
      <TimeLabel>
        <span>{item.createtime}</span>
        {item.duration && (
          <span>
            {Math.floor(item.duration / 60)}:{(item.duration % 60).toString().padStart(2, "0")}
          </span>
        )}
        {item.status === "2" && <span style={{ color: "var(--theme-main)" }}>生成中</span>}
      </TimeLabel>
    </AudioItem>
  )

  // 渲染文本内容项（回收站）
  const renderTextItem = (item: any) => (
    <TextItem key={item.id}>
      <ContentText>{item.content}</ContentText>
      <TimeLabel>
        <span>删除于: {item.deleted_time}</span>
        <div>
          <RestoreButton onClick={(e) => handleRestoreItem(item, e)}>恢复</RestoreButton>
          <DeleteButton onClick={(e) => handleDeleteItem(item, e)}>彻底删除</DeleteButton>
        </div>
      </TimeLabel>
    </TextItem>
  )

  return (
    <Container>
      <NavContainer>
        {navItems.map((item) => (
          <NavItem key={item.key} active={activeTab === item.key} isTrash={item.key === "trash"} onClick={() => handleTabChange(item.key)}>
            {item.label}
          </NavItem>
        ))}
      </NavContainer>

      <ContentArea>
        {/* 回收站显示清空按钮 */}
        {activeTab === "trash" && contentList.length > 0 && (
          <ClearTrashButton onClick={handleClearTrash} disabled={isLoading}>
            清空回收站
          </ClearTrashButton>
        )}

        {contentList.length === 0 && !isLoading ? (
          <EmptyState>
            <div className="icon">
              <span role="img" aria-label="文件夹">
                📁
              </span>
            </div>
            <div className="text">暂无内容</div>
          </EmptyState>
        ) : (
          <ContentGrid>
            {contentList.map((item) => {
              switch (activeTab) {
                case "avatar":
                  return renderVideoItem(item)
                case "voice":
                  return renderAudioItem(item)
                case "trash":
                  return renderTextItem(item)
                default:
                  return null
              }
            })}
          </ContentGrid>
        )}

        {isLoading && <LoadMoreButton>加载中...</LoadMoreButton>}

        {!hasMore && contentList.length > 0 && <LoadMoreButton>已加载全部内容</LoadMoreButton>}
      </ContentArea>
    </Container>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentLibrary)
